import { v4 as uuid } from 'uuid'
import type { StateCreator } from 'zustand'
import type { GiftAnimationQueue } from '../../types/lives/animations'

interface State {
  giftAnimationQueue: Record<string, GiftAnimationQueue[]> | null
  giftReceivedPerPosition: Record<string, string>
  // elementsPositions: Record<string, Positions>
}

interface Actions {
  enqueueGiftAnimation: (
    data: Omit<GiftAnimationQueue, 'id'>,
    numberOfSeats: number,
  ) => void
  removeGiftReceivedPerPosition: (position: number | 'streamer') => void
  dequeueGiftAnimation: (id: GiftAnimationQueue) => void
  // setElementPosition: (positions: Positions) => void
  // clearElementPosition: () => void
  // removeElementPosition: (positionId: string) => void
  clearQueueGiftAnimation: () => void
}

export type AnimationQueueSlice = State & Actions

export const animationQueueLiveStore: StateCreator<
  AnimationQueueSlice,
  [],
  [],
  AnimationQueueSlice
> = (set) => ({
  giftAnimationQueue: null,
  giftReceivedPerPosition: {},
  elementsPositions: {},
  enqueueGiftAnimation: (data) => {
    set((prevState) => {
      const id = uuid()
      const queue = { ...prevState?.giftAnimationQueue }
      const key = data?.userId

      // user sent id
      if (!queue[key]) {
        queue[key] = []
      }

      queue[key] = queue?.[key]?.concat({
        ...data,
        id,
      })

      return {
        giftAnimationQueue: queue,
      }
    })
  },
  removeGiftReceivedPerPosition: (position) => {
    set((prevState) => {
      const newGiftReceivedPerPosition = {
        ...prevState?.giftReceivedPerPosition,
      }

      delete newGiftReceivedPerPosition[position]

      return {
        giftReceivedPerPosition: newGiftReceivedPerPosition,
      }
    })
  },
  dequeueGiftAnimation: (queue) => {
    set((prevState) => {
      const newObj = { ...prevState.giftAnimationQueue }

      newObj[queue.userId] = newObj?.[queue?.userId]?.filter((queues) => {
        return queues?.id !== queue?.id
      })

      return { giftAnimationQueue: newObj }
    })
  },
  clearQueueGiftAnimation: () => {
    set({ giftAnimationQueue: {} })
  },
  // setElementPosition: (positions) => {
  //   set((prevState) => {
  //     const newObj = { ...prevState.elementsPositions }

  //     newObj[positions.id] = positions

  //     return { elementsPositions: newObj }
  //   })
  // },
  // clearElementPosition: () => {
  //   set({ elementsPositions: {} })
  // },
  // removeElementPosition: (positionId) => {
  //   set((prevState) => {
  //     const newObj = { ...prevState.elementsPositions }

  //     delete newObj[positionId]

  //     return { elementsPositions: newObj }
  //   })
  // },
})
